export default "__VITE_ASSET__ub8dVYlP__"